import { useCallback } from 'react';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { getMultiSelectionState } from '@components/MainStage/multiSelection.store';
import useStore from '@components/MainStage/store';
import { useProject } from '@context/Project';
import useResetViewport from '@hooks/canvas/useResetViewport';
import { canvasMap } from '@utils/canvas/CanvasMap';

const usePanelClick = ({ closeMenu }: { closeMenu: () => void }) => {
  const { unselectActiveEdge, unselectActiveNode } = useStore();
  const { handleCloseDrawer, drawer } = useProject();
  const resetViewPort = useResetViewport();

  return useCallback(() => {
    if (getFocusOnState().sourceId) {
      getMultiSelectionState().clear();
      closeMenu();
      return;
    }

    document.dispatchEvent(new Event('mousedown'));

    getMultiSelectionState().clear();
    unselectActiveEdge();
    unselectActiveNode();
    canvasMap.resetFocusedNode();

    closeMenu();
    handleCloseDrawer();

    if (drawer) {
      resetViewPort();
    }
  }, [drawer, handleCloseDrawer, closeMenu]);
};

export default usePanelClick;
